import type { ReactNode } from 'react';
import { AdminGlassDisclosure, type AdminGlassAccent } from '../AdminGlassDisclosure';
import type { CrmDealMacroId } from './crmDealStagePresets';

const ACCENT_MAP: Record<string, AdminGlassAccent> = {
  '#63B3ED': 'cyan',
  '#68D391': 'emerald',
  '#D6BCFA': 'violet',
  '#F6AD55': 'amber',
  '#FC814A': 'coral',
};

type Props = {
  /** Якорь для step-rail */
  macroId?: CrmDealMacroId;
  /** @deprecated use macroId */
  stepId?: CrmDealMacroId;
  title: string;
  subtitle?: string;
  accent?: string;
  badge?: ReactNode;
  icon?: ReactNode;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** Подсветка при task gate (409) */
  highlight?: boolean;
  children: ReactNode;
};

/** Секция карточки сделки — свёрнутая гармошка (без backdrop-filter в drawer). */
export function CrmDealAccordion({
  macroId,
  stepId,
  title,
  subtitle,
  accent = '#63B3ED',
  badge,
  icon,
  defaultOpen = false,
  open,
  onOpenChange,
  highlight = false,
  children,
}: Props) {
  const glassAccent = ACCENT_MAP[accent] ?? 'cyan';
  const anchor = macroId ?? stepId;

  return (
    <div
      id={anchor ? `crm-deal-macro-${anchor}` : undefined}
      className="scroll-mt-3 rounded-2xl"
      style={
        highlight
          ? {
              boxShadow: '0 0 0 2px rgba(252,129,74,0.85), 0 8px 24px rgba(252,129,74,0.15)',
              transition: 'box-shadow 0.25s ease',
            }
          : undefined
      }
    >
      <AdminGlassDisclosure
        accent={glassAccent}
        density="compact"
        defaultOpen={defaultOpen}
        open={open}
        onOpenChange={onOpenChange}
        expandSignal={highlight}
        title={title}
        subtitle={subtitle}
        badge={badge}
        icon={icon}
      >
        {children}
      </AdminGlassDisclosure>
    </div>
  );
}
